import { setupListeners } from "@reduxjs/toolkit/query";
import { productApi } from "../services/product";
import { configureStore } from "@reduxjs/toolkit";
import { campaignApi } from "../services/campaign";
import { adApi } from "../services/ad";
import { userApi } from "../services/user";
import { connectionsApi } from "../services/connections";
import authReducer from "./authSlice";
import tableReducer from "./tableSlice";
import navigationReducer from "./navigationSlice";
import { marketApi } from "../services/market";

const store = configureStore({
  reducer: {
    auth: authReducer,
    table: tableReducer,
    navigation: navigationReducer,
    [userApi.reducerPath]: userApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [campaignApi.reducerPath]: campaignApi.reducer,
    [adApi.reducerPath]: adApi.reducer,
    [connectionsApi.reducerPath]: connectionsApi.reducer,
    [marketApi.reducerPath]: marketApi.reducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // This can be removed if you no longer need to handle serialization issues
    }).concat([
      productApi.middleware,
      campaignApi.middleware,
      adApi.middleware,
      userApi.middleware,
      connectionsApi.middleware,
      marketApi.middleware,
    ]),
});

setupListeners(store.dispatch);

export default store;
